<template >
  <div class="formPosition" v-role="'ped'">
    <v-overlay :value="progresso">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <template>
        <v-container class="grey lighten-5">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <v-card class="elevation-5 rounded-lg">
          <!-- Título do Card -->
          <v-card-title class="text-h6 font-weight-bold grey lighten-3 py-3 px-4">
            <v-icon left color="primary">mdi-file-certificate</v-icon>
            Validar Certificado {{pesquisa}}
          </v-card-title>

          <v-divider></v-divider>

          <!-- Seção de Pesquisa -->
          <v-card-text class="pa-6">
            <v-container fluid>
              <v-row align="center" justify="center">
                <!-- Campo de pesquisa -->
                <v-col cols="12" sm="8" md="6">
                  <v-autocomplete
                  v-model="obj_estudante"
                  :items="estudantes"
                  :loading="isLoading_"
                  :search-input.sync="search"
                  color="primary"
                  item-text="params"
                  item-value="nome"
                  label="Nome do estudante"
                  placeholder="Pequise pelo nome do estudante"
                  prepend-icon="mdi-magnify"
                  return-object
                  @change="SelecionaEstudante()"
                  ></v-autocomplete>

                  <!-- <v-text-field
                    v-model="pesquisa"
                    label="Matrícula ou Bilhete"
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    class="rounded-lg"
                  ></v-text-field> -->
                </v-col>

                <!-- Botão de pesquisa -->
                <!-- <v-col cols="auto">
                  <v-btn
                    :disabled="!pesquisa"
                    color="primary"
                    @click="Pesquisar()"
                    class="elevation-3 rounded-lg px-4"
                  >
                    <v-icon left>mdi-search-web</v-icon> Pesquisar
                  </v-btn>
                </v-col> -->
              </v-row>

              <!-- Mensagens -->
              <v-row v-if="!msg_pesquisa || hasMessage" class="mt-4">
                <v-col cols="12" class="text-center">
                  <v-alert v-if="!msg_pesquisa" dense type="error" text class="rounded-lg">
                    <v-icon left>mdi-alert-circle</v-icon>
                    Estudante não encontrado!
                  </v-alert>
                  <v-alert v-if="hasMessage" dense :type="classMessage" class="rounded-lg">
                    {{ textMessage }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

           <!-- Dados Pessoais -->
            <v-card-subtitle class="text-h6 font-weight-bold primary--text">
              Dados Pessoais
            </v-card-subtitle>

          <!-- Seção de Informações do Estudante -->
          <v-card-text class="pa-4">
            <!-- Dados Pessoais -->
        <v-list dense class="mb-4">
  <v-list-item v-if="estudante_dados.length">
    <v-list-item-icon>
      <v-icon color="primary">mdi-account</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title class="font-weight-bold text-h6">
        {{ estudante_dados[0].nome }}
      </v-list-item-title>
      <v-list-item-subtitle class="text--secondary">
        <v-icon small color="grey">mdi-identifier</v-icon>
        Matrícula: {{ estudante_dados[0].idMatricula }} | BI:
        {{ estudante_dados[0].bi }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>

  <v-divider class="my-2"></v-divider>

  <v-list-item v-if="estudante_dados.length">
    <v-list-item-icon>
      <v-icon color="primary">mdi-gender-male-female</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-subtitle class="text--secondary">
        <strong>Gênero:</strong> {{ estudante_dados[0].sexo }} |
        <strong>Data de Nascimento:</strong>
        {{ estudante_dados[0].datanascimento }}
      </v-list-item-subtitle>
      
        <v-list-item-subtitle class="text--secondary">
           <strong class="text--secondary">Instituição:</strong> <!-- Destaque no texto -->
          <span class="font-weight-medium">{{ estudante_dados[0].instituicao }}</span> <!-- Destaque no nome da instituição -->
        </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>

  <v-divider class="my-2"></v-divider>

  <v-list-item v-if="estudante_dados.length">
    <v-list-item-icon>
      <v-icon color="primary">mdi-account-group</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-subtitle class="text--secondary">
        <v-icon small color="grey">mdi-account</v-icon>
        <strong>Filiação:</strong> {{ estudante_dados[0].nomedopai }}
        e {{ estudante_dados[0].nomedamae }}
      </v-list-item-subtitle>
      <v-list-item-subtitle class="text--secondary">
        <v-icon small color="grey">mdi-phone</v-icon>
        <strong>Contacto:</strong> {{ estudante_dados[0].telefone }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</v-list>
            <v-divider class="my-4"></v-divider>

            <!-- Histórico Acadêmico -->
            <v-card-subtitle class="text-h6 font-weight-bold primary--text">
              Histórico Acadêmico
            </v-card-subtitle>
             <v-data-table
                dense
                :headers="headers"
                :items="estudante_dados"
                hide-default-footer
                class="elevation-1 mt-4"
                :items-per-page="5" 
              >
  <!-- Personalização das células -->
  <template v-slot:item.descricao_curso="{ item }">
    <v-icon small class="mr-2">mdi-school</v-icon>
    {{ item.descricao_curso }}
  </template>

  <template v-slot:item.classe="{ item }">
    <v-chip small color="blue lighten-4" class="font-weight-bold">
      {{ item.classe }}
    </v-chip>
  </template>

  <template v-slot:item.descricao_turma="{ item }">
    <v-icon small class="mr-2">mdi-account-group</v-icon>
    {{ item.descricao_turma }}
  </template>

  <template v-slot:item.anoLectivo="{ item }">
    <v-chip small color="teal lighten-4" class="font-weight-bold">
      {{ item.anoLectivo }}
    </v-chip>
  </template>

  <template v-slot:item.resultado="{ item }">
    <v-chip
      :color="getResultadoColor(item.resultado)"
      dark
      small
    >
      {{ (item.resultado === 'Transita')?item.resultado:'Não Transita' }}
    </v-chip>
  </template>

  <!-- Personalização do cabeçalho -->
  <template v-slot:header.descricao_curso="{ header }">
    <v-icon small class="mr-2">mdi-school</v-icon>
    {{ header.text }}
  </template>

  <template v-slot:header.classe="{ header }">
    <v-icon small class="mr-2">mdi-book-open</v-icon>
    {{ header.text }}
  </template>

  <template v-slot:header.descricao_turma="{ header }">
    <v-icon small class="mr-2">mdi-account-group</v-icon>
    {{ header.text }}
  </template>

  <template v-slot:header.anoLectivo="{ header }">
    <v-icon small class="mr-2">mdi-calendar</v-icon>
    {{ header.text }}
  </template>

  <template v-slot:header.resultado="{ header }">
    <v-icon small class="mr-2">mdi-chart-line</v-icon>
    {{ header.text }}
  </template>
</v-data-table>
            <!-- Botão para abrir o diálogo de notas -->
            <v-row class="mt-4">
             <v-col cols="12" class="text-center">
  <v-btn
    color="primary"
    :disabled="loading || !estudante_dados.length"
    @click="getNotasCertificado()"
     class="elevation-2"
  >
    <v-icon v-if="!loading" left>mdi-certificate</v-icon>
    <v-progress-circular v-else indeterminate size="20" width="2" color="white"></v-progress-circular>
    <span v-if="!loading"> Ver Notas do Certificado</span>
    <span v-else> Carregando...</span>
  </v-btn>
</v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Diálogo para exibir as notas do certificado -->
    <v-dialog v-model="dialogNotas" max-width="800">
      <v-card>
        <v-card-title class="text-h6 font-weight-bold grey lighten-3 py-3 px-4">
          <v-icon left color="primary">mdi-certificate</v-icon>
          Notas do Certificado
        </v-card-title>
        <v-card-text class="pa-4">
          <!-- Lista de Notas -->
   <v-list dense style="max-height: 500px; overflow-y: auto;">
  <!-- Cabeçalho da tabela -->
  <v-list-item class="px-4">
    <v-row class="text-caption font-weight-bold" no-gutters>
      <v-col cols="1" class="text-center">Nº</v-col>
      <v-col cols="6">Disciplinas</v-col>
      <v-col cols="2" class="text-center">Nota</v-col>
    </v-row>
  </v-list-item>

  <v-divider></v-divider>

  <!-- Verifica se há dados -->
  <template v-if="notas.length > 0">
    <!-- Linhas da tabela -->
    <v-list-item v-for="(item, i) in notas" :key="i">
      <v-row no-gutters align="center">
        <!-- Número -->
        <v-col cols="1" class="text-center">
          <span class="text-body-2 font-weight-medium">{{ i + 1 }}.</span>
        </v-col>

        <!-- Nome da Disciplina -->
        <v-col cols="6">
          <v-list-item-title
            :class="{ 'font-weight-bold': item.iddisciplina < 0 }"
            v-text="item.descricao"
          ></v-list-item-title>
        </v-col>

        <!-- Nota -->
        <v-col cols="2" class="text-center">
          <p class="text-body-2">
            {{ item.mfd }}
          </p>
        </v-col>
      </v-row>
    </v-list-item>

    <v-divider></v-divider>

    <!-- Rodapé com Data de Emissão e Autor -->
    <v-list-item class="px-4">
      <v-row no-gutters align="center">
        <v-col cols="6" class="text-caption font-italic">
          📅 Data de Emissão: {{ notas[0].data_ }}
        </v-col>
        <v-col cols="6" class="text-caption font-italic text-right">
          ✍️ Autor: {{ notas[0].autor }}
        </v-col>
      </v-row>
    </v-list-item>
  </template>

  <!-- Mensagem para estudante sem certificado -->
  <template v-else>
    <v-list-item class="text-center py-5">
      <v-col class="text-body-1 font-italic text-grey">
        ⚠️ O estudante não possui certificado disponível.
      </v-col>
    </v-list-item>
  </template>
</v-list>



        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogNotas = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
    </template>
</div>
</template>

<script>
import axios from '../../plugins/axios'
import Swal from 'sweetalert2'
import Axios from 'axios'

const ls = require('local-storage')
export default {
 data: () => ({
   turmasMudancaCurso: [],
   inscricaoMudancaCurso: [],
   anolectivo: null,
   anoslectivo: [],
   isEtapa: false,
   dialog_show: false,
   dialog_cursoResultado: false,
   estudante_dados: [],
   idMatricula: null,
   loading: false,
   msg_pesquisa: true,
   dialogNotas: false, // Controla a visibilidade do diálogo
   motivo: '',
   cursoSelecionado: null,
   dialogo_turma: false,
   idanolectivo: 0,
   dialogo_curso: false,
   notas: [],
   dialogo_classe: false,
   classe_selecionada: '',
   classe_id: 0,
   turma_selecionada: '',
   estudantes:[],
   pesquisa: '',
   search:'',
   turmaSelecionada: null,
   cursos: [],
   cursos_filtered: [],
   estudante: true,
   progresso: false,
   selectedItem: null,
   dialog_confirmar2: false,
   progresso_2: false,
   progresso_3: false,
   obj_estudante: null,
   Pessoas: [],
   curso_selecionado_mc: '',
   turmasAll: [],
   turmas_filtered: [],
   turmas_filtered_mt: [],
   classesEstudante: [],
   dialog_curso: false,
   dialog_curso2: false,
   retornoMudanca: null,
   titulo: 'Historico Acadedémico',
   progress: false,
   Pessoas_filtro: [],
   Classes_filtradas: [],
   datebi: null,
   date: null,
   descricao: 'Nº do Bi',
   dialog_confirmar: false,
   dialogConfirmar: false,
   valid: true,
   menu: false,
   turmasAllAno: [],
   menubi: false,
   habilitaBi: false,
   showLink: false,
   overlay: false,
   cursosFiltrados: null,
   isLoading: true,
   nomeClasse: '',
   turmasFiltered: [],
   municipiosAll: [],
   itemAluno: null,
   cor: '',
   turmasAllFiltered: [],
   searchInDb: '',
   dialog: false,
   // eslint-disable-next-line standard/array-bracket-even-spacing
   classes: ['10ª Classe', '11ª Classe', '12ª Classe', '13ª Classe' ],
   ruleRequired: [value => value || 'campo obrigatorio'],

   defaultItem: {
     pkPessoa: 0,
     idPessoa: '',
     bi: '',
     idMunicipio: null,
     idPerfil: null,
     nome: '',
     morada: '',
     telefone: '',
     autor: '',
     datanascimento: '',
     data_: '',
     status_2: '',
     email: '',
     sexo: '',
     nomedopai: '',
     nomedamae: '',
     dataemissaobi: '',
     ResidenteEm: '',
     instituicao: '',
     instituicaodescricao: '',
     curso: null,
     turma: null,
     anoLectivo: '',
     idCurso: ''
   },
   editedItem:
   {
     nome: '',
     pkPessoa: '',
     idMatricula: '',
     bi: '',
     datanascimento: '',
     nomedopai: '',
     nomedamae: '',
     telefone: '',
     descricao_turma: '',
     instituicao: '',
     descricao_curso: '',
     anoLectivo: '',
     resultado: '',
     classe: '',
     idAno_Academico: '',
     idCurso: '',
     pkTurma: '',
     idAnoLectivo: 0,
     idTurma: '',
     idPessoa: '',
     idMAtricula: '',
     idMunicipio: null,
     idPerfil: null,
     morada: '',
     autor: '',
     data_: '',
     status_2: '',
     email: '',
     sexo: '',
     dataemissaobi: null,
     ResidenteEm: 1,
     instituicaodescricao: '',
     curso: null,
     turma: null,
     fkTurma: '',
     pkInscricao_na_turma: '',
     idano_academico: 0
   },

   items1: [
     'Aluno',
     'Funcionário'
   ],
   items2: [
     'Nome',
     'Bilhete de Identidade',
     'Número de Matricula'
   ],
   ano: [
     '2017',
     '2018',
     '2019',
     '2020'
   ],
   headers: [
     { text: 'Curso - Inscrito ', value: 'descricao_curso' },
     { text: 'Classes( Feitas )', value: 'classe' },
     { text: 'Turma', value: 'descricao_turma' },
     { text: 'Ano Lectivo', value: 'anoLectivo' },
     { text: 'Aproveitamento', value: 'resultado' }
   ],

 
   ruleTextRequired: [
     value => !!value || 'campo obrigatório.',
     value =>
       (value || '').length <= 50 || 'O máximo número de carácters atigidos',

     value => (value || '').length > 3 || 'carácteres insuficientes',
     value => {
       const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
       return !pattern.test(value) || 'Invalido.'
     }
   ]

 }),

 computed: {
   itIspossibleChangeLesson(){
     return (this.estudante_dados.filter(e=>e.idAno_Academico > 2)).length
   },
   idclasse () {
     return this.$store.state.idclasse
   },
   lsAnolectivo () {
     return ls.get('anolectivo')
   },
   role () {
     return ls.get('role')
   }
 },

 watch: {

    search (val) {
      // Items have already been loaded
    // this.estudantes = []
      // console.log('passouuuuuu' + this.estudantes.length)
      if (val.length > 3) {
      // Items have already been requested
        if (!this.estudantes.filter(t => t.nome.includes(val)).length) {
          this.estudantes = []
        }
        return this.PesquisarPeloEstudante(val)
      }
    }

  },
 created () {
   // check if classe has been selected otherwise send back to painel to select
   this.loadAnolectivo()
   this.initializeCursos()
   this.ObterIdAnoLectivo()
 },
 methods: {


    async SelecionaEstudante(){
       
       this.Pesquisar(this.obj_estudante.idMatricula)
      
    },

   async getNotasCertificado() {
    this.loading = true; // Ativa o spinner

    try {
      this.notas = await Axios.post(
        "https://chat.softlineangola.com/api/certificadoQrCode",
        { matricula:this.estudante_dados[0].idMatricula}
      ).then((res)=>res.data)

 
      this.dialogNotas = true
    } catch (error) {
      console.error("Erro ao obter notas do certificado:", error);
      return null;
    } finally {
      this.loading = false; // Desativa o spinner ao finalizar a requisição
    }
  },


    
 

   getResultadoColor(resultado) {
    if (resultado === "Transita") return "green"; // Aproveitamento positivo
    else return "red"; // Aproveitamento negativo
  },
// ***************************************************************************************
async  Pesquisar (params) {
     try {
       this.progresso = true
       this.estudante_dados = await axios
         .get('/PesquisaGeralEstudanteCertificado/' + params)
         .then(res => res.data)
       this.progresso = false
       if (!this.estudante_dados.length) { this.msg_pesquisa = false } else { this.msg_pesquisa = true }
     } catch (error) {
      console.log(error);
      
       this.progresso = false
     }
   },
   ObterClasse (idClasse) {
     if (idClasse === 1) { return '10ª Classe' }
     if (idClasse === 2) { return '11ª Classe' }
     if (idClasse === 3) { return '12ª Classe' }
     if (idClasse === 4) { return '13ª Classe' }
   },
   retornaClasse (idClasse) {
     if (idClasse[0].classe === 1) { this.nomeClasse = '10ª Classe' }
     if (idClasse[0].classe === 2) { this.nomeClasse = '11ª Classe' }
     if (idClasse[0].classe === 3) { this.nomeClasse = '12ª Classe' }
     if (idClasse[0].classe === 4) { this.nomeClasse = '13ª Classe' }
     this.pesquisarClassesEstudante().then(() => {
       this.dialog_cursoResultado = true
       this.dialog_curso2 = false
     })
   },
   show_mudarCurso () {
     this.dialogo_curso = true
     this.cursos_filtered = this.cursos.filter(c => c.idCurso !== this.editedItem.idCurso)
   },
   
   ObterIdClasse (classe) {
     if (classe === '10ª Classe') { this.classe_id = 1 } else if (classe === '11ª Classe') { this.classe_id = 2 } else if (classe === '12ª Classe') { this.classe_id = 3 } else if (classe === '13ª Classe') { this.classe_id = 4 }
   },

   ShowDialog () {
     this.dialog_show = true
   },
   
 

   Classe (idClasse) {
     if (idClasse === '10ª Classe') { return 1 }
     if (idClasse === '11ª Classe') { return 2 }
     if (idClasse === '12ª Classe') { return 3 }
     if (idClasse === '13ª Classe') { return 4 }
   },

   mudanca_classe () {
     this.dialogo_classe = true
     this.editedItem = Object.assign({}, this.estudante_dados[0])
     this.Classes_filtradas = this.classes.filter(p => p !== this.editedItem.classe)
   },

   async pesquisarClassesEstudante () {
     try {
       this.classesEstudante = await axios
         .get('/estudante-classes/' + this.estudante_dados[0].idMAtricula)
         .then(res => res.data)
     } catch (error) {
       Swal.fire('Informação', 'Ocorreu um erro ao pesquisar', 'error')
     }
   },
   
    async PesquisarPeloEstudante (params) {
      this.isLoading = true
        
        try {
          // this.isLoading = true
          this.estudantes = await axios
            .get('/pesquisaEstudanteNaTurma/' + params)
            .then(res => res.data)
          this.isLoading = false
         } catch (error) {
          this.isLoading = false
           this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        
      }
      this.isLoading = false
      this.isLoading_ = false
    },

 }

}

</script>
